/**
 * "Featured on tinyshelf" badge — required markup for the dofollow link on
 * tinyshelf.co. Their verification checker rejects the badge unless:
 *   - the href points at the https://www.tinyshelf.co landing page (the
 *     ?ref= query param is fine, and must be kept);
 *   - the anchor carries no rel="nofollow" / "sponsored" / "ugc";
 *   - the anchor is in the initial server HTML (satisfied here: `output:
 *     "export"` pre-renders the footer into every exported index.html);
 *   - the badge is served to every visitor, unconditionally — no A/B test,
 *     geo variant or cookie gate.
 *
 * Deliberately plain <a> and <img>: next/link adds nothing for an external
 * link, and next/image would refuse this cross-host URL without a
 * remotePatterns entry and proxy a 15KB SVG through our own build for
 * nothing. The badge host is allow-listed in the nginx CSP img-src.
 *
 * `h-16` pins the rendered height to the 64px the attributes declare.
 * Tailwind preflight sets `img { height: auto }`, which overrides the
 * height attribute, and Chrome then reports the lazy image as having no
 * explicit dimensions (DevTools Issues: "Lazy-loaded images should have
 * explicit dimensions").
 */
export function TinyshelfBadge() {
  return (
    <a href="https://www.tinyshelf.co/?ref=plugmonkey.xyz" title="Featured on tinyshelf">
      <img
        src="https://www.tinyshelf.co/badge/tinyshelf-badge-light-amber-1cdea1ce.svg"
        alt="Featured on tinyshelf"
        loading="lazy"
        decoding="async"
        width={216}
        height={64}
        className="h-16"
      />
    </a>
  );
}
